import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";
import "./index.css";
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import Sidebar from "./layout/sidebar";
import Navbar from "./layout/navbar";
import Login from "./pages/login";
import Home from "./pages/home";
import AboutUs from "./pages/aboutus";
import Residential from "./pages/residential";
import Industrial from "./pages/industrial";
import Contact from "./pages/contact";
import Footer from "./pages/footer";
import BlogsList from "./pages/blogs";
import BlogDetails from "./pages/blogs/BlogDetails";
import BlogPageSettings from "./pages/blogs/BlogPageSettings";
import HeaderSettings from "./pages/header";
import Leads from "./pages/leads";
import { ContextProvider, useStore } from "./utils/context";
import "react-quill/dist/quill.snow.css";

import { useState } from "react";

function App() {
  return (
    <Router className="">
      <div className="App">
        <ContextProvider>
          <ToastContainer style={{ zIndex: 999999 }} />
          <Routes>
            <Route path="/login" element={<NonAuthRoute />} />
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/residential" element={<Residential />} />
              <Route path="/industrial" element={<Industrial />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/footer" element={<Footer />} />
              <Route path="/blogs" element={<BlogsList />} />
              <Route path="/blogs/add" element={<BlogDetails />} />
              <Route path="/blogs/edit/:id" element={<BlogDetails />} />
              <Route path="/blog-page" element={<BlogPageSettings />} />
              <Route path="/header-settings" element={<HeaderSettings />} />
              <Route path="/leads" element={<Leads />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ContextProvider>
      </div>
    </Router>
  );
}

const AuthLayout = () => {
  const { isAuthenticated } = useStore();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen bg-[#f4f6fb]">
      <Navbar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex h-screen overflow-hidden pt-[68px]">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="flex-1 overflow-y-auto px-4 md:px-8 pb-20 ">
          <div className=" mx-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const NonAuthRoute = () => {
  const { isAuthenticated } = useStore();

  if (isAuthenticated) {
    return <Navigate to="/home" />;
  }
  return <Login />;
};

export default App;
